import React from "react";
import "./ContributionTable.css";
import Counties from "../../../config/CountiesConfig";
import {BurnModelUtils} from "../../../utils/burnModelUtils";
import {CountyOverlay} from "../../CountyOverlay";
import {FileUtils} from "../../../utils/fileUtils";


export class ContributionTable extends React.Component {


    constructor(props) {
        super(props);


        this.state = {
            countyContributionsToday: Counties,
            countyContributionsTomorrow: Counties
        }
    }

    async componentDidMount(){
        try {
            const [day0Csv, day1Csv] = await Promise.all([
                FileUtils.getContributionFileToday(this.props.cst),
                FileUtils.getContributionFileTomorrow(this.props.cst),
            ]);

            this.setState({
                countyContributionsToday:
                    BurnModelUtils.getCountyContributions(day0Csv),
                countyContributionsTomorrow:
                    BurnModelUtils.getCountyContributions(day1Csv)
            });

        } catch (err) {
            console.error("Failed to load contribution CSVs", err);
            this.setState({ loading: false });
        }
    }

    _renderContributionContent(showMap) {

       if(showMap){
           return this._renderMapContent()
       }
       else{
           return this._renderTableContent()
       }
    }

    _renderMapContent(){

        return(
            <tbody className="contribution-table-content">

                <tr>
                    <th colSpan={2}>
                        <div className="map-imgs-container">
                            <CountyOverlay
                                counties={this.state.countyContributionsToday}
                            />
                            <CountyOverlay
                                counties={this.state.countyContributionsTomorrow}
                            />
                        </div>
                    </th>
                </tr>

                <tr>
                    <th colSpan={2}>

                        <div className={"contribution-table-legend"}>
                            <div className={"contribution-table-legend-item"}>
                                <div className={"contribution-table-legend-icon legend-green"}/>
                                {this.props.i18n.Contribution_Table_Small}
                            </div>

                            <div className={"contribution-table-legend-item"}>
                                <div className={"contribution-table-legend-icon legend-yellow"}/>
                                {this.props.i18n.Contribution_Table_Medium}
                            </div>


                            <div className={"contribution-table-legend-item"}>
                                <div className={"contribution-table-legend-icon legend-red"}/>
                                {this.props.i18n.Contribution_Table_Large}
                            </div>

                            <div className={"contribution-table-legend-item"}>
                                <div className={"contribution-table-legend-icon legend-unavail"}/>
                                {this.props.i18n.Contribution_Table_Unavailable}
                            </div>

                            <div className={"contribution-table-legend-item"}>
                                <div className={"contribution-table-legend-icon legend-metro"}/>
                                {this.props.i18n.Contribution_Table_Metro}
                            </div>

                            <div className={"contribution-table-legend-item"}>
                                <div className={"contribution-table-legend-icon legend-monitor legend-circle"}/>
                                {this.props.i18n.Contribution_Table_Monitor}
                            </div>
                        </div>

                    </th>
                </tr>

            </tbody>


        )
    }

    _renderTableContent(){
        return(
            <tbody className="contribution-table-content">
                <tr>
                    <th colSpan={2}>
                        <div className={'map-content'}>
                            {this._renderInnerTable(this.state.countyContributionsToday)}
                            {this._renderInnerTable(this.state.countyContributionsTomorrow)}
                        </div>

                    </th>
                </tr>
            </tbody>
        )
    }

    _renderInnerTable(countyContributions){
        return(
            <table className="contribution-inner-table" cellPadding="0" cellSpacing="0">
                <thead className="contribution-table-head">
                    <tr>
                        <th className={"contribution-inner-column"}>
                            {this.props.i18n.Contribution_Table_County}
                        </th>
                        <th className={"contribution-inner-column"}>
                            {this.props.i18n.Contribution_Table_Contribution}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {countyContributions.map((county, idx) => (
                        <tr key={county.id}>
                            <td className={"contribution-table-inner-td"}>
                                {county.displayName}
                            </td>
                            <td
                                className={"contribution-table-inner-td-result"}
                                style={{backgroundColor:[county.backgroundColor]}}
                                onClick={() => {
                                    const params = new URLSearchParams(window.location.search);
                                    params.set("county", county.name);
                                    window.location.href = `/view/details/?${params.toString().replaceAll('%2F','/')}`;
                                }}
                            >
                                {county.contributionCategory || this.props.i18n.Contribution_Table_Unavailable}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }

    render() {


        return (
            <table className="contribution-table" cellPadding="0" cellSpacing="0">
                <thead className="contribution-table-head">

                <tr>
                    <th colSpan={2}>
                        {this.props.i18n.Contribution_Table_Header}
                    </th>
                </tr>

                <tr>
                    <th>{this.props.startDateString}</th>
                    <th>{this.props.endDateString}</th>
                </tr>

                <tr className="contribution-table-max">
                    <th colSpan={2}>
                        {this.props.i18n.Contribution_Table_Max}
                    </th>
                </tr>
                </thead>

                {this._renderContributionContent(this.props.showMap)}

            </table>

        );
    }
}
